import { Injectable } from "@angular/core";

export interface ChartOpts {}

@Injectable()
export class ChartConfigService {
  constructor() {}

  chartColors() {
    const genericColrSet = this.generateRandomColor(0.3, true);
    return [
      {
        backgroundColor: genericColrSet.color,
        borderColor: genericColrSet.opacColor,
        pointBackgroundColor: this.generateRandomColor(0.6),
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: this.generateRandomColor(0.8),
        pointHoverBorderColor: this.generateRandomColor(0.8),
        fill: true,
      },
    ];
  }

  generateRandomColor(valOpac: number, needOpacVarient = false): any {
    const o = Math.round;
    const r = Math.random;
    const s = 255;
    if (needOpacVarient) {
      const color = "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + ",";
      return {
        color: color + valOpac + ")",
        opacColor: color + "1)",
      };
    }
    return "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + "," + valOpac + ")";
  }

  configureChartToolTip(data, isUserChart?: boolean) {
    const tooltips = {
      enabled: true,
      callbacks: {
        label: (tooltipItem: { datasetIndex: string | number; formattedValue: string }) => {
          const labelText = isUserChart ? data[tooltipItem.datasetIndex].threadGroupConfigName + ": " : data[tooltipItem.datasetIndex].name + ": ";
          const label = [];
          label.push(labelText + tooltipItem.formattedValue);
          return label;
        },
      },
    };
    return tooltips;
  }
}
